"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { cn } from "@/lib/utils"

interface LegalSidebarProps {
    items: {
        label: string
        href: string
    }[]
}

export function LegalSidebar({ items }: LegalSidebarProps) {
    const pathname = usePathname()

    return (
        <nav className="space-y-1">
            {items.map((item) => (
                <Link
                    key={item.href}
                    href={item.href}
                    className={cn(
                        "group flex items-center rounded-md px-3 py-2 text-sm font-medium transition-colors",
                        pathname === item.href
                            ? "bg-primary/10 text-primary"
                            : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                    )}
                >
                    {item.label}
                </Link>
            ))}
        </nav>
    )
}
